module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("First published in Great Britain in 2022 by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Pen & Sword Military")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("An imprint of")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Pen & Sword Books Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Yorkshire – Philadelphia")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Copyright © John Carr 2022")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("ISBN 978 1 39908 781 0")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("eISBN 978 1 39908 782 7")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Mobi ISBN 978 1 39908 782 7")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("The right of John Carr to be identified as Author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("A CIP catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the Publisher in writing.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Pen & Sword Books Limited incorporates the imprints of Atlas, Archaeology, Aviation, Discovery, Family History, Fiction, History, Maritime, Military, Military Classics, Politics, Select, Transport, True Crime, Air World, Frontline Publishing, Leo Cooper, Remember When, Seaforth Publishing, The Praetorian Press, Wharncliffe Local History, Wharncliffe Transport, Wharncliffe True Crime and White Owl.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("For a complete list of Pen & Sword titles please contact")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("PEN & SWORD BOOKS LIMITED")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("47 Church Street, Barnsley, South Yorkshire, S70 2AS, England")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("E-mail: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:enquiries@pen-and-sword.co.uk"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("enquiries@pen-and-sword.co.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Website: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.pen-and-sword.co.uk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.pen-and-sword.co.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Or")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("PEN AND SWORD BOOKS")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("1950 Lawrence Rd, Havertown, PA 19083, USA")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("E-mail: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto://Uspen-and-sword@casematepublishers.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Uspen-and-sword@casematepublishers.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Website: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.penandswordbooks.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.penandswordbooks.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73bdc7ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 63
// module chunks = 0